module.exports = __webpack_public_path__ + "media/B27.81c6b44c.mp3";